export class Telefonnummer {
  nummer: string;
  vorwahl: string;

  constructor(vorwahl: string, nummer: string) {
    this.nummer = nummer ? nummer : '';
    this.vorwahl = vorwahl ? vorwahl : '';
  }
}
